import api from "../services/api";
import _ from "underscore";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        categories: [],
        saving: false,
        saveError: ""
    },
  
    getters: {
        
    },
  
    mutations: {
        setCategories(state, data) {
            // Setup the flag department Names
            data.forEach(function (category) {
                category.DepartmentNames = _.reduce(category.Departments, function (memo, dept) {
                    return memo + (memo != "" ? ", " : "") + dept.DepartmentName;
                }, "");

                category.ProductTypeNames = _.reduce(category.ProductTypes, function (memo, dept) {
                    return memo + (memo != "" ? ", " : "") + dept.ProductTypeName;
                }, "");
            });

            state.categories = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.categories = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        }
    },
  
    actions: {
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        saveCategory(context, options) {
            context.commit("saving");

            api.saveCategory(
                options.category,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of items (which will include the changes we requested)
                        context.commit("setCategories", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadCategories(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchCategories({
                    success: function(response) {
                        context.commit("setCategories", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        }
    }
}
